
import { AppService } from "app/services/app.service";


export abstract class AbNotificacaoFuncionalidade extends AppService {
  abstract exibirConfirmacao(funcionalidade: any): void;
  abstract exibirDialog(): void;
  abstract enviarNotificacao(funcionalidade: any);
  abstract goHome();
  abstract verificarModulo(): void;


}